import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer, roundTime } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DatePicker from 'react-datepicker';
import ReactQuill from 'react-quill';

// Components
import TimeSelect2 from '../Modules/TimeSelect2';
import BlackoutList from '../BlackoutDates/BlackoutList';

const MessageForm = observer(class MessageForm extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.createThreadCallback = this.createThreadCallback.bind(this);
  }

  componentWillMount() {
    const { threadObject } = this.props;

    this.state = {
      slot1Date: null,
      slot2Date: null,
      slot3Date: null,
      content: ''
    }

    if(threadObject.dateOption1) {
      this.setState({
        slot1Date: moment(threadObject.dateOption1)
      });
    }

    if(threadObject.dateOption2) {
      this.setState({
        slot2Date: moment(threadObject.dateOption2)
      });
    }

    if(threadObject.dateOption3) {
      this.setState({
        slot3Date: moment(threadObject.dateOption3)
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Auto focus text editor when reply button is clicked
    if(!prevProps.renderForm && this.props.renderForm) {
      this.refs.quill.focus();
    }
  }

  handleSlotChange(date, e, slot) {
    this.setState({
      [slot]: date
    })
  }

  handleContent(content) {
    this.setState({
      content
    });
  }

  handleSubmit() {
    const { MessageStore, SessionStore } = this.props.store;
    const { userTimezone } = this.props.store.SessionStore;

    const date1 = moment(this.state.slot1Date).format('YYYY-MM-DD');
    const timezone1 = moment(this.state.slot1Date).tz(userTimezone).format('Z');
    const date2 = moment(this.state.slot2Date).format('YYYY-MM-DD');
    const timezone2 = moment(this.state.slot2Date).tz(userTimezone).format('Z');
    const date3 = moment(this.state.slot3Date).format('YYYY-MM-DD');
    const timezone3 = moment(this.state.slot3Date).tz(userTimezone).format('Z');

    const data = {
      initiatingUserSid: SessionStore.userData.userSid,
      courseSid: SessionStore.userData.courseSid,
      sessionRequest: this.props.sessionRequest || false,
      content: this.state.content
    }

    if(this.slot1Time && this.slot2Time && this.slot3Time) {
      if(this.props.sessionRequest && date1 && date2 && date3) {
        data.dateOption1 = moment(`${date1} ${this.slot1Time.value} ${timezone1}`, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
        data.dateOption2 = moment(`${date2} ${this.slot2Time.value} ${timezone2}`, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
        data.dateOption3 = moment(`${date3} ${this.slot3Time.value} ${timezone3}`, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
      }
    }

    if(this.props.examSid) {
      data.examSid = this.props.examSid;
    }

    // if(this.props.examConfigurationSid) {
    //   data.examConfigurationSid = this.props.examConfigurationSid;
    // }

    if(this.props.proctorApprovalSid) {
      data.proctorApprovalSid = this.props.proctorApprovalSid;
    }

    if(this.props.examSessionEventReportSid) {
      data.examSessionEventReportSid = this.props.examSessionEventReportSid;
    }

    if(this.props.proctorSid) {
      data.toProctorAccountUserSid = this.props.proctorSid;
    }

    if(this.props.toUserSid && !this.props.proctorSid) {
      data.toUserSid = this.props.toUserSid;
    }

    if(this.props.proctorLocationSid) {
      data.locationSid = this.props.proctorLocationSid;
    }

    // Send the form data
    if(data.content) {
      if(this.props.mode === 'create') {
        // Creating a new thread
        MessageStore.createThread(data, this.createThreadCallback);
      } else {
        // Replying to an existing thread
        data.source = 'messenger';
        data.fromUserSid = data.initiatingUserSid;

        delete data.courseSid;
        delete data.examSid;
        delete data.examConfigurationSid;
        delete data.examSessionEventReportSid;
        delete data.initiatingUserSid;
        delete data.proctorApprovalSid;
        delete data.sessionRequest;
        delete data.toProctorAccountUserSid;
        delete data.toUserSid;
        delete data.locationSid;

        MessageStore.replyToThread(this.props.threadSid, data);
      }

      // Clear out the content
      this.setState({
        content: ''
      });

      this.props.parentThread.setState({
        renderForm: false
      })
    } else {
      const editor = document.querySelector('.quill');

      if(editor) {
        editor.className += ' error';
      }
    }
  }

  createThreadCallback() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    SessionStore.showToaster(translation.message_sent, 'success');
    closeDrawer(null, this.props.parent);
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { examSession } = this.props;
    const { userTimezone } = this.props.store.SessionStore;
    let minDate = null;
    let absMinDate = null;
    let maxDate = null;
    let startTime = '00:00';
    let endTime = '00:00'

    let examConfiguration = this.props.examConfiguration;

    if(!examConfiguration && examSession) {
      examConfiguration = examSession.examConfiguration
    }

    if(examConfiguration) {
      const now = moment(this.props.store.SessionStore.currentTime);
      minDate = moment(examConfiguration.examOpenDate).tz(userTimezone);
      absMinDate = moment(minDate).startOf('hour');
      maxDate = moment(examConfiguration.examCloseDate).endOf('hour').add(1, 'minutes').tz(userTimezone);
      const timeDiff = moment.duration(minDate.diff(now)).asHours();

      if(timeDiff < 0) {
        minDate = now;
      }

      startTime = moment(absMinDate).format('HH:mm');
      endTime = moment(maxDate).format('HH:mm');
    }

    // Quill text editor toolbar options
    const modules = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'bullet'}, {'list': 'ordered'}]
      ]
    };

    const now = moment(this.props.store.SessionStore.currentTime);
    let expired = false;
    const expirationDate = moment(this.props.confirmedDateExpiration);
    const scheduleDiff = moment.duration(expirationDate.diff(now)).asHours();

    if(scheduleDiff < 0) {
      expired = true;
    }

    if(this.props.renderForm) {
      return (
        <form className={`message-form ${SessionStore.backgroundLoading ? 'working' : ''}`} onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
          <ul className="fields">
            <li>
              <ReactQuill
                modules={modules}
                onChange={(e) => {this.handleContent(e)}}
                ref="quill"
              />
            </li>
          </ul>

          {this.props.sessionRequest && !this.props.confirmedDate &&
            <h4 className="form-heading" aria-describedby="dates-tooltip">
              {translation.requested_dates}

              <div className="tooltip">
                <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                <div id="dates-tooltip" className="tooltip__body" role="tooltip">{translation.date_request}</div>
              </div>
            </h4>
          }

          {this.props.sessionRequest &&
            <BlackoutList {...this.props} />
          }

          {this.props.sessionRequest &&
            <p className="note">{translation.schedule_note}</p>
          }

          {/* {this.props.sessionRequest && !this.props.confirmedDate && */}
          {((this.props.sessionRequest && !this.props.confirmedDate) || (this.props.confirmedDate && expired)) &&
            <ul className="fields">
              <li>
                <label className="lbl-required" htmlFor="slot-1">{translation.slot_1.label}</label>

                <DatePicker
                  id="exam-start-date"
                  placeholderText={translation.slot_1.helper}
                  selected={this.state.slot1Date ? moment(this.state.slot1Date) : null}
                  openToDate={moment(examConfiguration.examOpenDate).tz(userTimezone)}
                  minDate={minDate}
                  maxDate={moment(examConfiguration.examCloseDate).tz(userTimezone)}
                  onChange={(date, e) => {this.handleSlotChange(date, e, 'slot1Date')}}
                  required
                  aria-required="true"
                  autoComplete="off"
                />

                <span className="preposition">{translation.slot_at}</span>

                <label className="select">
                  <select
                    defaultValue={roundTime(this.state.slot1Date)}
                    ref={(input) => {this.slot1Time = input}}
                  >
                    <TimeSelect2
                      startTime={
                        moment(this.state.slot1Date).isSame(absMinDate, 'day') ? startTime : null
                      }
                      endTime={
                        moment(this.state.slot1Date).isSame(maxDate, 'day') ? endTime : null
                      }
                    />
                  </select>
                </label>

                <span className="preposition">
                  {/* If a date is selected, use that date’s dst */}
                  {this.state.slot1Date &&
                    moment.utc(this.state.slot1Date).tz(userTimezone).format('z')
                  }

                  {/* Otherwise use the current date’s dst */}
                  {!this.state.slot1Date &&
                    moment().tz(userTimezone).format('z')
                  }
                </span>
              </li>
              <li>
                <label className="lbl-required" htmlFor="slot-2">{translation.slot_2.label}</label>

                <DatePicker
                  id="exam-start-date"
                  placeholderText={translation.slot_2.helper}
                  selected={this.state.slot2Date ? moment(this.state.slot2Date) : null}
                  openToDate={moment(examConfiguration.examOpenDate).tz(userTimezone)}
                  minDate={minDate}
                  maxDate={moment(examConfiguration.examCloseDate).tz(userTimezone)}
                  onChange={(date, e) => {this.handleSlotChange(date, e, 'slot2Date')}}
                  required
                  aria-required="true"
                  autoComplete="off"
                />

                <span className="preposition">{translation.slot_at}</span>

                <label className="select">
                  <select
                    defaultValue={roundTime(this.state.slot2Date)}
                    ref={(input) => {this.slot2Time = input}}
                  >
                    <TimeSelect2
                      startTime={
                        moment(this.state.slot2Date).isSame(absMinDate, 'day') ? startTime : null
                      }
                      endTime={
                        moment(this.state.slot2Date).isSame(maxDate, 'day') ? endTime : null
                      }
                    />
                  </select>
                </label>

                <span className="preposition">
                  {/* If a date is selected, use that date’s dst */}
                  {this.state.slot2Date &&
                    moment.utc(this.state.slot2Date).tz(userTimezone).format('z')
                  }

                  {/* Otherwise use the current date’s dst */}
                  {!this.state.slot2Date &&
                    moment().tz(userTimezone).format('z')
                  }
                </span>
              </li>
              <li>
                <label className="lbl-required" htmlFor="slot-3">{translation.slot_3.label}</label>

                <DatePicker
                  id="exam-start-date"
                  placeholderText={translation.slot_3.helper}
                  selected={this.state.slot3Date ? moment(this.state.slot3Date) : null}
                  openToDate={moment(examConfiguration.examOpenDate).tz(userTimezone)}
                  minDate={minDate}
                  maxDate={moment(examConfiguration.examCloseDate).tz(userTimezone)}
                  onChange={(date, e) => {this.handleSlotChange(date, e, 'slot3Date')}}
                  required
                  aria-required="true"
                  autoComplete="off"
                />

                <span className="preposition">{translation.slot_at}</span>

                <label className="select">
                  <select
                    defaultValue={roundTime(this.state.slot3Date)}
                    ref={(input) => {this.slot3Time = input}}
                  >
                    <TimeSelect2
                      startTime={
                        moment(this.state.slot3Date).isSame(absMinDate, 'day') ? startTime : null
                      }
                      endTime={
                        moment(this.state.slot3Date).isSame(maxDate, 'day') ? endTime : null
                      }
                    />
                  </select>
                </label>

                <span className="preposition">
                  {/* If a date is selected, use that date’s dst */}
                  {this.state.slot3Date &&
                    moment.utc(this.state.slot3Date).tz(userTimezone).format('z')
                  }

                  {/* Otherwise use the current date’s dst */}
                  {!this.state.slot3Date &&
                    moment().tz(userTimezone).format('z')
                  }
                </span>
              </li>
            </ul>
          }

          <button className="btn" type="submit">{translation.send}</button>
        </form>
      )
    } else {
      return (
        <div className="inbox__init-reply">
          <button className="btn--link" onClick={this.props.showForm}>{translation.reply}</button> {translation.to_message}
        </div>
      )
    }
  }
})

export default translate('MessageForm')(MessageForm);



// WEBPACK FOOTER //
// ./src/app/components/Messages/MessageForm.js